import {css} from 'styled-components';

export const subTitleTypography = css`
  font-size: 26px;
  line-height: 30px;
  font-weight: 800;
`;
